
define('modules/application/wizard/steps/zoneStep/complexZoneStep/audioVideoZoneStep/zonesMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zonesMenuView",
  "./zoneMenuView",
  "../../separatorMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZonesMenuView,
  ZoneMenuView,
  SeparatorMenuView) {

  var audioVideoZonesMenuView = ZonesMenuView.extend({

    addConstructors : function() {
      this.ZoneMenuView = ZoneMenuView;
    },

    initialize         : function() {
      ZonesMenuView.prototype.initialize.apply(this);

      BticinoS4B.Instances.Models.ApplicationModel.unbind("change:filterId", this.render);
      BticinoS4B.Instances.Models.ApplicationModel.bind("change:filterId", this.render, this);
    },

    insertAdditionalZones : function() {
      //Variable declarations
      var viewToSelect,
          that                  = this, viewToInsert,
          additionalZones       = this.model.additionalZones,
          additionalZonesLength = additionalZones.length,
          filterId              = BticinoS4B.Instances.Models.ApplicationModel.get("filterId"),
          compatibleZones       = [];

      switch(filterId)
      {
        case 1 :
        case 2 : compatibleZones = [-305, -304, -303]; //Zone di gestione citofonia
                 break;
        case 3 : compatibleZones = [-302, -300];       //Zone di gestione diffusione sonora
                 break;
        case 4 :
        case 5 : compatibleZones = [-305, -304, -303, -302, -300];
                 break;
      }

      //Inserting views for the additional zones
      var numberOfSeparators = 2;
      for (i=0; i<additionalZonesLength; i++)
      {
        if (additionalZones[i].role!=="separator" && _.indexOf(compatibleZones, additionalZones[i].get("number")) !== -1)
        {
          additionalZones[i].set("stepEventAggregator", that.options.stepEventAggregator);
          additionalZones[i].set("sortable", false);
          viewToInsert = new that.ZoneMenuView({model : additionalZones[i], stepEventAggregator : that.options.stepEventAggregator});
          if ( /*( (filterId===-1) || (filterId===1) || (filterId===2) ) && */(viewToSelect===undefined) )
            viewToSelect = viewToInsert;
          viewToInsert.setAsLocked();
          that.insertView("#zoneList", viewToInsert);
        }
        else if (additionalZones[i].role==="separator")
        {
          if (filterId)
          {
            if (numberOfSeparators===2)
            {
              if (filterId===1 || filterId===2 || filterId===4 || filterId===5)
              {
                viewToInsert = new SeparatorMenuView();
                viewToInsert.name = additionalZones[i].name;
                that.insertView("#zoneList", viewToInsert);
              }
            }
            else if (numberOfSeparators===1)
            {
              if (filterId===3 || filterId===4 || filterId===5)
              {
                viewToInsert = new SeparatorMenuView();
                viewToInsert.name = additionalZones[i].name;
                that.insertView("#zoneList", viewToInsert);
              }
            }
            numberOfSeparators--;
          }
        }
      }

      return viewToSelect;
    },

    insertRegularZones    : function() {
      var that            = this,
          number          = 1,
          filterId        = BticinoS4B.Instances.Models.ApplicationModel.get("filterId"),
          viewToSelect;

      if ( (filterId!==-1) && (filterId!==1) && (filterId!==2) )
      {
        //Inserting views for the classic zones
        this.model.collection.each(function(currentModel) {
          currentModel.set("number", number);
          currentModel.set("sortable", true);
          viewToInsert = new that.ZoneMenuView({model : currentModel, stepEventAggregator : that.options.stepEventAggregator});
          that.insertView("#zoneList", viewToInsert);
          number++;
          viewToSelect = viewToInsert;
        });
      }

      return viewToInsert;
    },

    beforeRender : function() {
      var viewToSelect,
          filterId        = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

      viewToSelect = this.insertAdditionalZones();

      //if ( (filterId!==-1) && (filterId!==1) && (filterId!==2) )
      if ((BticinoS4B.Instances.Models.ApplicationModel.get("zoneInserted")) && (BticinoS4B.Instances.Models.ApplicationModel.get("zoneLength")>0))
      {
        viewToSelect = this.insertRegularZones();
        BticinoS4B.Instances.Models.ApplicationModel.set("zoneInserted", false);
      }
      else
        this.insertRegularZones();

      if (viewToSelect)
        window.BticinoS4B.eventAggregator.trigger("zone:selected", viewToSelect);
    },

    afterRender           : function() {
      var filterId        = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");
      ZonesMenuView.prototype.afterRender.apply(this);

      //if ( (filterId===-1) || (filterId===1) || (filterId===2) )
      //  this.$el.find("h5 *").hide();
    }

  });

  //Creating final audioVideoZoneStep class
  audioVideoZonesMenuView.extend({
    objClass      : "audioVideoZonesMenuView"
  });

  // Required, return the module for AMD compliance
  return audioVideoZonesMenuView;

});